// Activity feed accordion — lazy-fetches a chronological merge of stage
// transitions, session events, and intake proposals.

import { useState, type JSX } from "react";

import { useT } from "../../i18n/index.js";
import { useProjectActivity } from "../useProjectActivity";

import { Accordion } from "./Accordion";
import { ActivityBody } from "./ActivityBody";

interface ActivityAccordionProps {
  readonly projectId: number;
}

export const ActivityAccordion = ({
  projectId,
}: ActivityAccordionProps): JSX.Element => {
  const t = useT();
  const [opened, setOpened] = useState(false);
  const { events, loading, error } = useProjectActivity(projectId, opened);
  return (
    <Accordion
      icon="history"
      title={t("dashboard.accordion.projectActivity")}
      count={t("dashboard.accordion.recent")}
      onOpenChange={(open) => {
        if (open) setOpened(true);
      }}
    >
      <ActivityBody events={events} loading={loading} error={error} />
    </Accordion>
  );
};
